import SEO from '@/components/SEO';
import HeroSection from '@/components/about/HeroSection';
import WhySection from '@/components/about/WhySection';
import ActionSection from '@/components/about/ActionSection';
import OurStorySection from '@/components/about/OurStorySection';
import TeamSection from '@/components/about/TeamSection';
import ValuesSection from '@/components/about/ValuesSection';
import ClosingSection from '@/components/about/ClosingSection';

const WhySeniorThrive = () => {
  return (
    <>
      <SEO 
        title="About Us - SeniorThrive"
        description="Learn about SeniorThrive's mission to empower seniors to live independently at home. Our story, values, and commitment to changing the conversation about aging."
        keywords="about senior care, aging in place, independent living, senior safety, family caregiving, SeniorThrive mission"
      />
      
      <HeroSection />
      <WhySection />
      <ActionSection />
      <OurStorySection />
      <TeamSection />
      <ValuesSection />
      <ClosingSection />
    </>
  );
};

export default WhySeniorThrive;